import React from "react";

const FeatureDetails = (props) => {
  const { title, titleColor_1, titleColor_2, description, image, points, rev } =
    props.detail;

  const flexRowClass = `md:flex gap-5 flex-row ${
    rev ? "flex-row-reverse" : ""
  }`;

  return (
    <div className="flex  md:mx-12 md:px-14 my-4 mx-2 px-6">
      <div className={flexRowClass}>
        <div className="hidden md:flex flex-col w-[50%]">
          <img loading="lazy" src={image} alt="reward" />
        </div>
        <div className="md:flex md:flex-col items-center justify-center md:ml-5 md:w-[46%]">
          <div className="md:text-5xl text-2xl font-extrabold text-center md:text-start">
            <span className="font-bold text-primary">{titleColor_1} </span>
            <span className="font-bold text-black">{title} </span>
            <span className="font-bold text-primary">{titleColor_2}</span>
          </div>
          <div className="md:hidden flex">
            <img loading="lazy" src={image} alt="reward" />
          </div>
          <div className="md:mt-12 mt-6 md:text-xl">
            {description}
            <br />
            <br />
            <ul className="list-disc px-12 md:text-lg">
              {points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureDetails;
